import type { StoryObj } from "@storybook/react";
import Testimonial from "../components/Text/Testimonial";

const meta = {
    title: "Example/Testemonial",
    component: Testimonial,
};
export default meta;
type Story = StoryObj<typeof meta>;

export const Testemonial: Story = {
    args: {
        differentTextColor: "text-lightYellow",
    },
};
export const TestemonialBlackImg: Story = {
    args: {
        backgroundColor: "bg-black",
        textColor: "text-white",
        hasImage: true,
        name: "Sandra Smith",
        icon: "/Icons/quoteIconPink.svg",
        text: "Thank Rico for such a great help for my family! Appreciate it.",
        wordsInDifferentColor: [],
        hasDescription: false,
    },
};
export const TestimonialLight: Story = {
    args: {
        text: "Ich freue mich sehr, dass Sie ihr Angebot für die Menschen zu einem erschwinglichen Preis anbieten. So kann jeder Stärke und Selbstregulation für für sich persönlich erfahren.",
        backgroundColor: "bg-white",
        name: "Christiane Weber",
        textColor: "text-black",
        hasDescription: true,
        description: "Marburg DE",
        wordsInDifferentColor: ["Stärke", "für", "sich", "persönlich"],
        differentTextColor: "text-pink",
    },
};
export const TestimonialYellow: Story = {
    args: {
        text: "In über 40’000 Einzelsitzungen  konnte ich meine Forschungsergebnisse immer wieder aufs Neue bestätigen.",
        name: "Rico Brunner",
        hasDescription: true,
        description:
            "Entwickelte die Arbeitsweise der Energiefeld-Instandsetzung vor über 25 Jahren",
        textColor: "text-black",
        backgroundColor: "bg-yellow",
        wordsInDifferentColor: [
            "40’000",
            "Einzelsitzungen",
            "Forschungsergebnisse",
            "bestätigen",
        ],
        differentTextColor: "text-red",
    },
};
export const TestimonialBlue: Story = {
    args: {
        text: "Menschen sind widerstandsfähig und belastbar, wenn ihr Energiefeld funktioniert.",
        backgroundColor: "bg-blue",
        name: "Rico Brunner",
        hasDescription: true,
        description: "Spezialisiert in Energiefeld-Instandsetzung seit 1998",
        wordsInDifferentColor: [
            "widerstandsfähig",
            "belastbar",
            "Energiefeld",
            "funktioniert.",
        ],
        differentTextColor: "text-lightYellow",
    },
};
export const TestemonialOrange: Story = {
    args: {
        text: "Das Verständnis der Energiefeldmechanik kann man leider nicht aus Büchern lernen, weil die Variablen und Möglichkeiten zu vielfältig sind. Man muss sie erkennen, um sie zu verstehen.",
        backgroundColor: "bg-orange",
        name: "Rico Brunner",
        hasDescription: true,
        description: "Spezialist im Erkennen der Energiefeldmechanik",
        wordsInDifferentColor: [
            "der",
            "Energiefeldmechanik",
            "kann",
            "man",
            "leider",
            "nicht",
            "aus",
            "Büchern",
            "lernen,",
        ],
        differentTextColor: "text-lightYellow",
    },
};
